export const TABS_HEIGHT = 55